export enum ServingType {
  Congregate = "Congregate",
  NonCongregate = "Non-Congregate",
}
